import React from 'react';
import { NavLink } from 'react-router-dom';
import './navlink.css';

const NavLinks = (props) => {
  return (
    <NavLink
      to={props.to}
      className={({ isActive }) =>
        `link_div ${isActive ? 'active-link' : ''} ${props.className || ''}`
      }
    >
      {props.icon && <img src={props.icon} alt="" className="icon" />}
      <span className="nav_text">{props.text}</span>
    </NavLink>
  );
};

export default NavLinks;